module.exports = __webpack_public_path__ + "img/about_bg.b406b9a1.png";